export const formatCurrency =
  ({ maximumFractionDigits } = {}) =>
  (value) => {
    const intlInstance = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits,
    });

    return intlInstance.format(value);
  };
